<template>
  <div ref="menuWrapper" class="relative flex justify-center card">
    <button
      :disabled="erpDLoading"
      @click="!loadingItem && toggle()"
      class="flex items-center h-10 px-3 py-2 space-x-1 text-sm text-gray-700 border rounded-lg bg-gray-50 hover:bg-gray-100 w-32"
      :class="{ 'cursor-not-allowed': erpDLoading, 'cursor-wait': loadingItem }"
    >
      <span>{{ translateText("settings.pushToERP") }}</span>
      <img
        v-if="!erpDLoading"
        src="@/assets/svg/arrow-right.svg"
        alt="arrow"
        class="w-5 h-5"
      />
      <ClipLoaderVue v-else color="black" :size="20" />
    </button>

    <!-- MAIN MENU -->
    <transition name="fade-slide" mode="out-in">
      <div
        v-if="menuVisible"
        class="absolute top-12 left-0 z-50 bg-white border rounded-lg shadow-md w-56"
      >
        <div
          v-for="(item, index) in mainMenu"
          :key="index"
          class="px-5 py-3 hover:bg-gray-100 flex justify-between"
          :class="{
            'bg-gray-100': activeMainMenu === item,
            'hover:bg-gray-100': activeMainMenu !== item,
            'cursor-wait': loadingItem,
            'cursor-pointer': !loadingItem,
          }"
          @click="!loadingItem && openSubMenu(item)"
        >
          <div class="flex gap-2 text-sm text-gray-700">
            <img :src="item.icon" alt="arrow" class="w-5 h-5" />
            {{ item.label }}
          </div>
          <img
            src="@/assets/svg/chevron-right.svg"
            alt="arrow"
            class="w-5 h-5"
          />
        </div>
      </div>
    </transition>

    <!-- Submenu -->
    <transition name="fade-slide" mode="out-in">
      <div
        v-if="subMenuVisible"
        :key="subMenuRenderKey"
        key="submenu"
        class="absolute top-12 left-56 z-50 bg-white border rounded-lg shadow-md w-36 transition-transform duration-200 ease-out"
      >
        <div
          v-for="(sub, i) in activeSubMenu"
          :key="i"
          class="px-4 py-3 hover:bg-gray-100 flex justify-between"
          :class="{
            'cursor-wait': loadingItem,
            'cursor-pointer': !loadingItem,
          }"
          @click="!loadingItem && handleSubClick(sub)"
        >
          <div class="flex items-center gap-2 text-sm text-gray-700">
            <img :src="sub.icon" alt="arrow" class="w-5 h-5" />

            {{ sub.label }}
            <ClipLoaderVue
              class="ml-1"
              v-show="loadingItem === sub.label"
              color="black"
              :size="15"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>

  <!--🚨 NO ERP MODAL  -->
  <section>
    <ConfirmPassword
      :isPasswordConfirmOpen="confirmERPModal"
      :closePasswordConfirm="closeERPModal"
      :isModal="true"
      :modalWidth="600"
      :title="translateText('settings.pushToERP')"
      :headerImg="'link-active.svg'"
    >
      <section class="my-4 content-center pattern">
        <div class="mt-5">
          <img src="@/assets/svg/ERP-img.svg" alt="" class="m-auto h-28" />
        </div>

        <p class="mb-5 text-lg font-semibold text-center mt-5">
          {{ translateText("settings.erpLinkSet") }}
        </p>

        <p
          v-if="entityType == 'company'"
          class="mb-5 text-[#545454] text-sm leading-6 text-center mt-3"
        >
          {{ translateText("settings.erpModal1") }}
        </p>
        <p
          v-else
          class="mb-5 text-[#545454] text-sm leading-6 text-center mt-3"
        >
          {{ translateText("settings.erpModal2") }}
        </p>

        <div
          v-if="entityType == 'company'"
          class="flex items-center m-auto w-[70%] mb-9"
        >
          <ButtonVue
            @handleClick="routeSettings"
            theme="positiveSolid"
            size="medium"
            radius="small"
          >
            <p class="text-base font-medium">
              {{ translateText("settings.goToSettings") }}
            </p></ButtonVue
          >
        </div>
      </section>
    </ConfirmPassword>
  </section>
</template>

<script>
import {
  translateText,
  getImage,
  successToast,
  errorToast,
  getEntityQuery,
} from "@/core/helpers/utility";

//stores
import { mapActions, mapState } from "pinia";
import { useSettingsStore } from "@/store/Settings";

export default {
  props: {
    pushedERP: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["pushToERP"],

  data() {
    return {
      translateText,
      getImage,
      getEntityQuery,

      menuVisible: false,
      subMenuVisible: false,
      activeSubMenu: [],
      activeMainMenu: null,
      erpDLoading: false,
      activeERP: false,
      subMenuRenderKey: 0,

      confirmERPModal: false,

      entityId: null,
      entityType: null,

      loadingItem: null,
      loadingCall: true,

      mainMenu: [
        {
          label: translateText("settings.exEpumpRec"),
          icon: getImage("document-text.svg"),
          subItems: [
            {
              label: translateText("settings.asCSV"),
              icon: getImage("table-cells.svg"),
              erpType: "csv",
              reportType: "epump",
              command: () => successToast("Epump CSV"),
            },
            {
              label: translateText("settings.asJSON"),
              icon: getImage("code-circle.svg"),
              erpType: "json",
              reportType: "epump",
              command: () => successToast("Epump JSON"),
            },
          ],
        },
        {
          label: translateText("settings.exManualVol"),
          icon: getImage("table-cells.svg"),
          subItems: [
            {
              label: translateText("settings.asCSV"),
              icon: getImage("table-cells.svg"),
              erpType: "csv",
              reportType: "manual",
              command: () => successToast("Manual CSV"),
            },
            {
              label: translateText("settings.asJSON"),
              erpType: "json",
              reportType: "manual",
              icon: getImage("code-circle.svg"),
              command: () => successToast("Manual JSON"),
            },
          ],
        },
      ],
    };
  },
  watch: {
    pushedERP(oldVal, newVal) {
      if (oldVal !== newVal) {
        // console.log("close out triggered");
        this.closeOut();
      }
    },
  },

  mounted() {
    document.addEventListener("click", this.handleClickOutside);

    const { entityId, entityType } = getEntityQuery(this.$route.query);
    this.entityId = entityId;
    this.entityType = entityType;

    // if (this.entityType == "company") {
    this.fetchERPStatus();
    // }
  },

  beforeDestroy() {
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    toggle() {
      this.activeMainMenu = null;
      if (this.activeERP) {
        this.menuVisible = !this.menuVisible;
        this.subMenuVisible = false;
      } else {
        this.confirmERPModal = true;
      }
    },

    openSubMenu(item) {
      this.activeMainMenu = item;
      // if submenu is already open for this item → close it
      if (
        this.subMenuVisible &&
        this.activeSubMenu.length &&
        this.activeSubMenu === item.subItems
      ) {
        this.activeMainMenu = null;
        this.subMenuVisible = false;
        this.activeSubMenu = [];
        return;
      }

      // otherwise, open the new submenu
      this.activeSubMenu = item.subItems || [];
      this.subMenuVisible = true;

      this.subMenuRenderKey++;
    },

    async handleSubClick(sub) {
      this.loadingItem = sub.label;
      document.removeEventListener("click", this.handleClickOutside);
      document.body.style.cursor = "wait";
      this.$emit("pushToERP", sub);
      successToast(translateText("settings.pushingERP"));

      // try {
      //   if (typeof sub.command === "function") {
      //     await sub.command();
      //   }

      // } catch (error) {
      //   console.error("Error executing sub command:", error);
      // } finally {
      //   this.closeOut();
      // }
    },

    closeOut() {
      this.loadingItem = null;
      document.body.style.cursor = "default";
      document.addEventListener("click", this.handleClickOutside);
      this.toggle();
    },

    handleClickOutside(event) {
      const menuEl = this.$refs.menuWrapper;
      if (menuEl && !menuEl.contains(event.target)) {
        this.menuVisible = false;
        this.subMenuVisible = false;
        this.activeMainMenu = null;
      }
    },

    closeERPModal() {
      this.confirmERPModal = false;
    },

    routeSettings() {
      this.$router.push({ name: "settings", query: { tab: "erp" } });
    },

    ...mapActions(useSettingsStore, ["getERPDetails"]),

    fetchERPStatus() {
      this.erpDLoading = true;
      this.getERPDetails(this.entityId, this.entityType)
        .then((res) => {
          if (res.data.data) {
            this.activeERP = true;
          }
          // this.erp = res.data.data;
        })
        .finally(() => {
          this.erpDLoading = false;
        });
    },
  },
};
</script>

<style scoped>
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.2s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(-5px);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-5px);
}
</style>
